export default __webpack_public_path__ + "static/media/pan.e7c18655.png";